/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 12:08:48
 * @FilePath: \jyrg-web\src\config\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  // 二维码
  gameCodeText: "扫一扫下载游戏",
  weChatCodeText: "关注微信公众号",
  // 公告
  announcement: "官网公告",
  gamePreserve: "更新维护",
  gameMaterial: "游戏资料",
  playStrategy: "江湖传闻",

  inviteLink: "https://www.q1000y.cn/order",
  // 页脚
  footer: {
    familySafety: {
      id: 0,
      title: "家长监护",
      type: "footer",
    },
    service: {
      id: 1,
      title: "联系客服",
      type: "footer",
    },
    userAgreement: {
      id: 4,
      title: "用户协议",
      type: "footer",
    },
    privacyPolicy: {
      id: 5,
      title: "隐私政策",
      type: "footer",
    },
    recordsText1: "蜀ICP备2022014484号",
    recordsText2: "-2ISBN 978-7-498-09082-9",
    hintText:
      "适度游戏益脑 沉迷游戏伤身 抵制不良游戏 拒绝盗版游戏 注意自我防护",
  },

  baseUrl: {
    // development: "http://192.168.10.38:18080",
    development: "https://www.q1000y.cn",
    production: "https://www.q1000y.cn",
  },
  baseHighUrl: {
    // development: "http://192.168.10.38:18080",
    development: "https://q1000y.cn/high",
    production: "https://q1000y.cn/high",
  },
  baseThreeUrl: {
    development: "https://q1000y.cn/three",
    production: "https://q1000y.cn/three",
  },
  rechargeUrl: {
    // development: "http://192.168.10.38:15001/",
    development: " https://cb.q1000y.cn/payment",
    production: "https://cb.q1000y.cn/payment",
  },
  testRechargeUrl: {
    // development: "http://192.168.10.38:15001/",
    development: " https://cb.q1000y.cn/payment",
    production: "https://cb.q1000y.cn/taiji",
  },
  orderBaseUrl: {
    development: "https://reservation.q1000y.cn/",//这是也是线上
    production: "https://www.q1000y.cn", //这是线上
    //   development: "http://192.168.10.17:9993/",//这是也是线上
    // production: "http://192.168.10.17:9993/", //这是线上
  },

  //
  tabList: [
    { id: 1, name: "最新", tab: "new" },
    { id: 2, name: "公告", tab: "0" },
    { id: 3, name: "活动", tab: "2" },
    { id: 4, name: "攻略", tab: "1" },
    { id: 5, name: "更多", tab: "more" },
  ],

  //
  tabName: {
    1: "指南",
    2: "装备",
    3: "武学",
    4: "地图",
  },

  //
  mediaTab: [
    { id: 1, name: "精彩视频" },
    { id: 2, name: "精美壁纸" },
    { id: 3, name: "游戏截图" },
  ],

  //
  dataTabList: [
    {
      name: "游戏介绍",
      tab: 1,
      backgroundImg: require("@/assets/image/pc/people-tab1.png"),
    },
    {
      name: "装备大全",
      tab: 2,
      backgroundImg: require("@/assets/image/pc/people-tab2.png"),
    },
    {
      name: "武学秘籍",
      tab: 3,
      backgroundImg: require("@/assets/image/pc/people-tab3.png"),
    },
    {
      name: "NPC/怪物",
      tab: 4,
      backgroundImg: require("@/assets/image/pc/people-tab4.png"),
    },
  ],
  dataInfoList: [
    {
      name: "正式-帝王",
      title: "正式服资料",
      selectType:'threeExplosive',
      tab:3,
      defaultClass: 'item-three-def' ,
      backgroundImg: require("@/assets/image/pc/people-info4.png"),
    },
    {
      name: "经典怀旧",
      title: "经典怀旧服资料",
      backgroundImg: require("@/assets/image/pc/people-info2.png"),
      tab: 1,
      selectType:'official',
      defaultClass: 'item-def' // 正式服默认样式类
    },
    {
      name: "高爆服",
      title: "高爆服资料",
      selectType:'highExplosive',
      tab: 2,
      defaultClass: 'item-high-def' ,
      backgroundImg: require("@/assets/image/pc/people-info1.png"),
    },
 
   
  ],


  outsidelinkList: [
    {
      name: "微信",
      w: 54,
      h: 47,
      src: require("@/assets/image/pc/icon-wechat.png"),
      codesrc: require("@/assets/image/pc/wechat-code-transparency.png"),
      hover: true,
      offset: 0,
      describe: "群侠传微信公众号,用微信扫描左侧二维码",
      link: "",
      account: "q_1000y",
    },
    {
      name: "QQ",
      w: 42,
      h: 47,
      src: require("@/assets/image/pc/icon-qq.png"),
      codesrc: "",
      hover: true,
      offset: 70,
      describe: "群侠传官方Q群,用QQ扫描左侧二维码",
      link: "",
      account: "",
    },
    {
      name: "抖音",
      w: 41,
      h: 48,
      src: require("@/assets/image/pc/icon-dy.png"),
      codesrc: require("@/assets/image/pc/douyin-code.png"),
      hover: true,
      offset: 70,
      describe: "群侠传抖音账号,用抖音扫描左侧二维码",
      link: "",
      account: "",
    },
    {
      name: "TapTap",
      w: 46,
      h: 45,
      src: require("@/assets/image/pc/icon-tap.png"),
      codesrc: require("@/assets/image/pc/taptap-code.png"),
      hover: false,
      offset: 0,
      describe: "TapTap",
      link: "https://www.taptap.cn/app/538749",
      account: "",
    },
    {
      name: "好游快爆",
      w: 47,
      h: 46,
      tab: 4,
      src: require("@/assets/image/pc/icon-haoyou.png"),
      codesrc: "",
      hover: false,
      offset: 0,
      describe: "",
      link: "https://www.3839.com/a/163394.htm",
      account: "",
    },
  ],

  orderPrizeList: [
    {
      name: "生汤药*1000",
      value: "预约人数满1万",
      orderNum: 10000,
      image_mb_dark: require("@/assets/image/mb/order/prize-sty-dark.png"),
      image_mb_light: require("@/assets/image/mb/order/prize-sty-light.png"),
      image_pc_dark: require("@/assets/image/pc/order/prize-sty-dark.png"),
      image_pc_light: require("@/assets/image/pc/order/prize-sty-light.png"),
    },
    {
      name: "福寺草*200",
      value: "预约人数满2万",
      orderNum: 20000,
      image_mb_dark: require("@/assets/image/mb/order/prize-fsc-dark.png"),
      image_mb_light: require("@/assets/image/mb/order/prize-fsc-light.png"),
      image_pc_dark: require("@/assets/image/pc/order/prize-fsc-dark.png"),
      image_pc_light: require("@/assets/image/pc/order/prize-fsc-light.png"),
    },
    {
      name: "洗髓丹*1",
      value: "预约人数满5万",
      orderNum: 50000,
      image_mb_dark: require("@/assets/image/mb/order/prize-xsd-dark.png"),
      image_mb_light: require("@/assets/image/mb/order/prize-xsd-light.png"),
      image_pc_dark: require("@/assets/image/pc/order/prize-xsd-dark.png"),
      image_pc_light: require("@/assets/image/pc/order/prize-xsd-light.png"),
    },
    {
      name: "执剑令*10",
      value: "预约人数满10万",
      orderNum: 100000,
      image_mb_dark: require("@/assets/image/mb/order/prize-sm-dark.png"),
      image_mb_light: require("@/assets/image/mb/order/prize-sm-light.png"),
      image_pc_dark: require("@/assets/image/pc/order/prize-sm-dark.png"),
      image_pc_light: require("@/assets/image/pc/order/prize-sm-light.png"),
    },
  ],

  inviteActivityList: [
    {
      count: 1,
      image_pc_dark: require("@/assets/image/pc/order/lottery-dark.png"),
      image_pc_light: require("@/assets/image/pc/order/lottery-light.png"),
    },
    {
      count: 2,
      image_pc_dark: require("@/assets/image/pc/order/lottery-dark.png"),
      image_pc_light: require("@/assets/image/pc/order/lottery-light.png"),
    },
    {
      count: 3,
      image_pc_dark: require("@/assets/image/pc/order/lottery-dark.png"),
      image_pc_light: require("@/assets/image/pc/order/lottery-light.png"),
    },
  ],

  specialPrizeList: [
    {
      id: 5,
      name: "华为MatePad Pro平板",
      label: "",
      image: require("@/assets/image/mb/order/prize/p1.png"),
      image_pc: require("@/assets/image/pc/order/prize/p1.png"),
    },
    {
      id: 4,
      name: "华为Mate 60 Pro+手机",
      label: "",
      image: require("@/assets/image/mb/order/prize/p2.png"),
      image_pc: require("@/assets/image/pc/order/prize/p2.png"),
    },
    {
      id: 1,
      name: "雨中客时装",
      label: "",
      image: require("@/assets/image/mb/order/prize/p3.png"),
      image_pc: require("@/assets/image/pc/order/prize/p3.png"),
    },
    {
      id: 2,
      name: "玉仙时装",
      label: "",
      image: require("@/assets/image/mb/order/prize/p4.png"),
      image_pc: require("@/assets/image/pc/order/prize/p4.png"),
    },
    {
      id: 6,
      name: "福寺草(绑)*50",
      label: "",
      image: require("@/assets/image/mb/order/prize/p5.png"),
      image_pc: require("@/assets/image/pc/order/prize/p5.png"),
    },
    {
      id: 3,
      name: "生汤药*200",
      label: "",
      image: require("@/assets/image/mb/order/prize/p6.png"),
      image_pc: require("@/assets/image/pc/order/prize/p6.png"),
    },
  ],

  probabilityList: [
    {
      prize: "华为Mate 60 Pr0+手机",
      quantity: "1",
      luckyValue: "0.001%",
    },
    {
      prize: "华为MatePad Pro平板",
      quantity: "1",
      luckyValue: "0.001%",
    },
    {
      prize: "雨中客时装",
      quantity: "30",
      luckyValue: "0.038%",
    },
    {
      prize: "玉仙时装",
      quantity: "30",
      luckyValue: "0.038%",
    },
    {
      prize: "福寺草*50",
      quantity: "4938",
      luckyValue: "6.17%",
    },
    {
      prize: "生汤药*200",
      quantity: "75000",
      luckyValue: "93.75%",
    },
  ],
};
